/** Synchronous hooks run at the start of a venue switch (navigation, UI reset). */
type VenueSwitchPrepare = () => void;

const prepares = new Set<VenueSwitchPrepare>();

export function onVenueSwitchPrepare(fn: VenueSwitchPrepare): () => void {
  prepares.add(fn);
  return () => prepares.delete(fn);
}

export function runVenueSwitchPrepare(): void {
  for (const fn of prepares) fn();
}

/** Routes that reference a specific session from the previous venue. */
export function venueSwitchTargetPath(pathname: string, search: string): string | null {
  if (/^\/history\/[^/]+/.test(pathname)) return '/history';
  if (pathname === '/sessions/new') return '/';
  if (search.includes('session=')) return pathname || '/';
  return null;
}
